export default "__VITE_ASSET__DeRyRAkS__"